<div>
    <app-notification class="sticky-notification" title="Enregistrement impossible" color="#e37055" *ngIf="errorMessages.length && !isValidForm">
        <ul>
          <li *ngFor="let error of errorMessages">{{error}}</li>
        </ul>
    </app-notification>
    <div class="content-add-title-wrapper">
        <h2 class="admin-page-title margin-top">{{ isEdition ? 'Modifier' : 'Ajouter une nouvelle' }} {{ isEdition ? 'la' : ''}} ressource</h2>
        <app-icon
            *ngIf="isEdition"
            class="margin-top"
            (click)="deleteContent()"
            type="trash"
            size="30"
            button></app-icon>

    </div>
    
    <form class="margin-top" [formGroup]="contentForm">
        <div class="row gap">
            <div class="create-content-title-wrapper">
                <app-input title="Titre" formControlName="title"></app-input>
            </div>
        </div>
        <div>
            <p>Description</p>
            <div class="NgxEditor__Wrapper margin-top">
                <ngx-editor-menu [toolbar]="toolbar" [editor]="editor"></ngx-editor-menu>
                <ngx-editor
                    [editor]="editor"
                    formControlName="description"
                    [placeholder]="'Décrivez la ressource...'">
                </ngx-editor>
            </div>
        </div>
        <div class="column gap">
            <!-- Note: Objectif field removed per REMOVE-OBJECTIF.txt requirements -->
            <div class="row">
                <app-radio-buttons class="create-content-format-item" formControlName="format" title="Format" [options]="formatsNames"></app-radio-buttons>
                <div class="duration-container">
                    <div>Durée</div>
                    <input class="time-input" type="time" step="1" formControlName="readingDuration" value="00:00:00">
                </div>
            </div>
            <ng-container  *ngIf="contentForm?.get('format')?.value">
                <div>Média associé</div>
                <p class="media-help-text" *ngIf="!content">
                    Sélectionnez un fichier - l'upload se fera automatiquement lors de l'enregistrement
                </p>
                <div class="existing-media-indicator" *ngIf="content?.resource && !fileModified">
                    <div class="existing-media-badge">
                        <app-icon type="check" size="16"></app-icon>
                        <span>Fichier existant</span>
                    </div>
                    <div class="existing-media-info">
                        <small>{{ content.resource }}</small>
                    </div>
                </div>
                <div class="create-content-media-container">
                    <div class="create-content-media-flex-item">
                        <app-upload-large-file
                            #uploadLargeFileComponent
                            [mimeTypes$]="acceptingMimeTypes$"
                            (updateFile)="updateFile($event)"
                            (uploadComplete)="onUploadComplete($event)"
                            (uploadError)="onUploadError($event)"
                            (uploadProgress$)="onUploadProgress($event)"
                            [update]="!!content"
                            showMessage="false"
                            showFileName="true"
                            [image]="isImageFormat()"
                            [video]="isVideoFormat()"
                            [audio]="isAudioFormat()"
                            [pdf]="isPdfFormat()"
                            entityName="contents"
                            [entityId]="content?.id || ''"
                            [isCover]="false">
                        </app-upload-large-file>
                    </div>
                    <div class="create-content-media-flex-item or-wrapper">ou</div>
                    <app-input class="create-content-media-flex-item" title="Url" formControlName="resource"></app-input>
                </div>
            </ng-container>
        </div>
        <div class="row gap margin-top">
            <div class="column create-content-flex-item">
                <!-- Note: Changed from checkboxes to radio buttons - only ONE pillar can be selected per REMOVE-OBJECTIF.txt -->
                <app-radio-buttons
                    formControlName="pillar"
                    title="Pilier lié"
                    [options]="pillarNames">
                </app-radio-buttons>

                <app-checkmarks title="Thématique(s) liée(s)" [checkboxes]="thematicsAssociatedCheckboxes" item-name="selectionné"
                (changeSelection)="updateThematicsAssociated($event)"></app-checkmarks>
            </div>
            <!-- Note: Catégorie field removed per REMOVE-OBJECTIF.txt requirements -->
        </div>
        <div>
            <p class="margin-bottom">Image de couverture</p>
            <app-upload-file [mimeTypes$]=" coverImageMimeTypes$" [showFileName]="!showCoverImageUrl"  [showImageUrl]="showCoverImageUrl" [imageUrl]="coverImageUrl" (updateFile)="updateCoverImage($event)" [update]="!!content" hasLimit="false" showMessage="false" image></app-upload-file>
            <div class="cover-image-container">
                <img class="cover-image" *ngIf="showCoverImageUrl" [src]="coverImageUrl" alt="Media Image">
            </div>
        </div>
    </form>
</div>
